var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTag = function SvgTag(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "black",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7395 16.0529L17.9433 9.2567C17.6675 8.9847 17.2898 8.8147 16.8742 8.8147H11.5853C10.7504 8.8147 10.0742 9.49091 10.0742 10.3258V15.6147C10.0742 16.034 10.2442 16.4118 10.52 16.6838L17.32 23.4838C17.592 23.7558 17.9698 23.9258 18.3853 23.9258C18.8009 23.9258 19.1825 23.7558 19.4545 23.4838L24.7433 18.1949C25.0153 17.9191 25.1853 17.5414 25.1853 17.1258C25.1853 16.7065 25.0153 16.3287 24.7395 16.0529ZM12.7187 12.5925C12.0916 12.5925 11.5853 12.0863 11.5853 11.4592C11.5853 10.832 12.0916 10.3258 12.7187 10.3258C13.3458 10.3258 13.852 10.832 13.852 11.4592C13.852 12.0863 13.3458 12.5925 12.7187 12.5925Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.0742,
    y: 8.8147,
    width: 15.1111,
    height: 15.1111,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tag.fa15201d5f8b4f6c9dd2bbd5209ff80c.svg";